import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SendAllEmailRoutingModule } from './send-all-email-routing.module';
import { SendAllEmailComponent } from './send-all-email.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CustomExcelMapperModule } from 'src/app/shared/custom-excel-mapper/custom-excel-mapper.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    SendAllEmailComponent
  ],
  imports: [
    CommonModule,
    SendAllEmailRoutingModule,
    SharedModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    MatDatepickerModule,
    CustomExcelMapperModule,
    MatFormFieldModule,
    MatAutocompleteModule

  ],
  exports: [SendAllEmailComponent]
})
export class SendAllEmailModule { }
